import { Link } from "react-router-dom";
import SectionHeading from "@/components/feature/SectionHeading";
import { topics } from "@/mocks/topics";

export default function TopicsPreview() {
  return (
    <section className="w-full bg-background-50">
      <div className="w-full px-4 md:px-8 py-14 md:py-20">
        <SectionHeading
          eyebrow="TOPICS"
          title="按栏目逛热点"
          desc="不同话题更新节奏不一样。先选一个你常看的栏目，之后刷新就能更快定位到想看的内容。"
          action={
            <Link
              to="/topics"
              className="inline-flex items-center gap-2 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap cursor-pointer"
            >
              进入分类专题页
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line" aria-hidden="true"></i>
              </span>
            </Link>
          }
        />

        <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {topics.map((topic) => (
            <Link
              key={topic.slug}
              to="/topics"
              className="group relative flex flex-col overflow-hidden rounded-lg border border-background-300/60 bg-background-100 hover:border-primary-300 transition-colors cursor-pointer"
            >
              <div className="w-full h-40 overflow-hidden bg-background-200">
                <img
                  src={topic.image}
                  alt={`${topic.name}栏目配图`}
                  className="w-full h-full object-cover object-top group-hover:scale-[1.04] transition-transform duration-500"
                />
              </div>
              <div className="flex flex-1 flex-col p-5">
                <div className="flex items-center justify-between gap-3">
                  <h3 className="font-heading text-lg font-bold text-foreground-950 group-hover:text-primary-600 transition-colors">
                    {topic.name}
                  </h3>
                  <span className="rounded-full bg-secondary-50 px-2.5 py-1 text-[11px] text-secondary-800">
                    {topic.count} 条
                  </span>
                </div>
                <p className="mt-2.5 text-sm leading-6 text-foreground-600 line-clamp-2">{topic.desc}</p>
                <span className="mt-auto pt-4 inline-flex items-center gap-1.5 text-sm text-primary-600">
                  进入栏目
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-arrow-right-line" aria-hidden="true"></i>
                  </span>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}